<template>
	<div class="landing-page privacy">

		<!-- Top navbar -->
		<landing-page-navbar></landing-page-navbar>
		<div class="content-container">

			<div class="container" v-if="carrierDetails">
				<div class="row">
					<div class="col-md-10 col-lg-8">
						<dd v-if="carrierDetails.privacyLink">
							<span v-html="carrierDetails.privacyLink"></span>
						</dd>
						<dd v-else>
							<div class="privacy">
								<div class="header">
									<h1>PRIVACY POLICY</h1>
									<p>This Application collects some Personal Data from its Users.</p>
									<p>Personal Data collected for the following purposes and using the following services:</p>
								</div>

								<div class="contain">
									<div id="smallPolicy">
										<h3>Analytics</h3>
										<p><strong>Google Analytics and Google Adwords conversion tracking</strong>
											<br>Personal Data: Cookies and Usage data
										</p>

										<h3>Contacting The User</h3>
										<strong>Contact form</strong>
										<p>Personal Data: address, country, email address, first name, last name, phone number and ZIP/Postal code</p>

										<strong>Mailing List or Newsletter</strong>
										<p>Personal Data: email address</p>

										<strong>Phone contact</strong>
										<p>Personal Data: phone number</p>


										<h3>Displaying Content From External Platforms</h3>
										<strong>Google Maps widget</strong>
										<p>Personal Data: Cookies and Usage data</p>

										<div v-if="carrierDetails.usesKlarna">
											<h3>Heat Mapping</h3>
											<strong>SessionCam</strong>
											<p>Personal Data: Cookies and Usage data</p>
										</div>

										<h3>Contact information</h3>
										<strong>Data owner</strong>
										<p>{{ carrierDetails.address }}</p>

										<div v-if="carrierDetails.usesKlarna">
											<h3>Klarna Payments</h3>
											<p>
												In order to be able to offer you Klarna’s payment options, we will pass to Klarna certain aspects of your personal information, such as contact and order details, in order for Klarna to assess whether you qualify for their payment options and to tailor the payment options for you.
												General information on Klarna can be found <a href="https://www.klarna.com/uk/" target="_blank">here</a>. Your personal data is handled in accordance with applicable data protection law and in accordance with the information in Klarna’s privacy policy.
											</p>
										</div>
									</div>

									<div id="fullPolicy" style="display: none;">
										(Full Privacy Policy)

										<h3>Types of Data collected</h3>

										<p>Among the types of Personal Data that this Application collects, by itself or through third parties, there are: first name, last name, phone number, address, country, email address, Postal code, Cookies and Usage data.</p>

										<p>Other Personal Data collected may be described in other sections of this privacy policy or by dedicated explanation text contextually with the Data collection.
											The Personal Data may be freely provided by the User, or collected automatically when using this Application.</p>

										<p>Any use of Cookies - or of other tracking tools - by this Application or by the owners of third party services used by this Application, unless stated otherwise, serves to identify Users and remember their preferences, for the sole purpose of providing the service required by the User.
											Failure to provide certain Personal Data may make it impossible for this Application to provide its services.</p>

										<p>Users are responsible for any Personal Data of third parties obtained, published or shared through this Application and confirm that they have the third party's consent to provide the Data to the Owner.</p>


										<h3>Mode and place of processing the Data</h3>

										<p>Methods of processing
											The Data Controller processes the Data of Users in a proper manner and shall take appropriate security measures to prevent unauthorised access, disclosure, modification, or unauthorised destruction of the Data.</p>

										<p>The Data processing is carried out using computers and/or IT enabled tools, following organisational procedures and modes strictly related to the purposes indicated. In addition to the Data Controller, in some cases, the Data may be accessible to certain types of persons in charge, involved with the operation of the site (administration, sales, marketing, legal, system administration) or external parties (such as third party technical service providers, mail carriers, hosting providers, IT companies) appointed, if necessary, as Data Processors by the Owner. The updated list of these parties may be requested from the Data Controller at any time.</p>

										<strong>Place</strong>
										<p>The Data is processed at the Data Controller's operating offices and in any other places where the parties involved with the processing are located. For further information, please contact the Data Controller.</p>



										<strong>Retention time</strong>
										<p>The Data is kept for the time necessary to provide the service requested by the User, or stated by the purposes outlined in this document, and the User can always request that the Data Controller suspend or remove the data.</p>




										<h3>The use of the collected Data</h3>
										<p>The Data concerning the User is collected to allow the Owner to provide its services, as well as for the following purposes: Contacting the User, Analytics, Heat mapping, Displaying content from external platforms.</p>

										<p>The Personal Data used for each purpose is outlined in the specific sections of this document.</p>



										<h3>Detailed information on the processing of Personal Data</h3>
										<p>Personal Data is collected for the following purposes and using the following services:</p>


										<h3>Analytics:</h3>
										<p>The services contained in this section enable the Owner to monitor and analyse web traffic and can be used to keep track of User behaviour.</p>

										<strong>Google Analytics (Google Inc.)</strong>
										<p>Google Analytics is a web analysis service provided by Google Inc. (“Google”). Google utilises the Data collected to track and examine the use of this Application, to prepare reports on its activities and share them with other Google services.
											Google may use the Data collected to contextualise and personalise the ads of its own advertising network.</p>

										<p>Personal Data collected: Cookies and Usage data.</p>

										<p>Place of processing: US – Privacy Policy (https://www.google.com/intl/en/policies/privacy/)  – Opt Out (https://tools.google.com/dlpage/gaoptout?hl=en)</p>

										<strong>Google AdWords conversion tracking (Google Inc.)</strong>
										Google AdWords conversion tracking is an analytics service provided by Google Inc. that connects data from the Google AdWords advertising network with actions performed on this Application.

										<p>Personal Data collected: Cookies and Usage data.</p>

										<p>Place of processing: US – Privacy Policy (https://www.google.com/intl/en/policies/privacy/)</p>



										<h3>Contacting The User</h3>
										<strong>Contact form (This Application)</strong>
										<p>By filling in the contact form with their Data, the User authorises this Application to use these details to reply to requests for information, quotes or any other kind of request as indicated by the form’s header.</p>

										<p>Personal Data collected: address, country, email address, first name, last name, phone number and ZIP/Postal code.</p>

										<strong>Phone contact (This Application)</strong>
										<p>Users that provided their phone number might be contacted for commercial or promotional purposes related to this Application, as well as for fulfilling support requests.</p>

										<p>Personal Data collected: phone number.</p>

										<h3>Displaying content from external platforms</h3>
										<p>This type of services allows you to view content hosted on external platforms directly from the pages of this Application and interact with them.</p>
										<p>This type of service might still collect web traffic data for the pages where the service is installed, even when Users do not use it.</p>

										<strong>Google Maps widget (Google)</strong>
										<p>Google Maps is a maps visualisation service provided by Google Inc. that allows this Application to incorporate content of this kind on its pages.</p>

										<p>Personal Data collected: Usage data.</p>

										<p>Place of processing: US – Privacy Policy (https://www.google.com/intl/en/policies/privacy/)</p>

										<div v-if="carrierDetails.usesKlarna">
											<h3>Heat Mapping</h3>
											<p>Heat Mapping services are used to display the areas of a page where Users most frequently move the mouse or click. This shows where the points of interest are. These services make it possible to monitor and analyse web traffic and keep track of User behaviour.</p>

											<p>Crazy Egg (Crazy Egg, Inc.) is a Heat Mapping service provided by Crazy Egg, Inc.</p>

											<p>Personal Data collected: Cookies and Usage data.</p>

											<p>Place of processing: US - Privacy Policy (Crazy Egg Privacy Policy - https://www.crazyegg.com/privacy)</p>
										</div>


										<h3>Additional information about Data collection and processing</h3>
										<strong>Legal action</strong>
										<p>The User's Personal Data may be used for legal purposes by the Data Controller, in Court or in the stages leading to possible legal action arising from improper use of this Application or the related services.</p>

										<p>The User declares to be aware that the Data Controller may be required to reveal personal data upon request of public authorities.</p>

										<strong>Additional information about User's Personal Data</strong>
										<p>In addition to the information contained in this privacy policy, this Application may provide the User with additional and contextual information concerning particular services or the collection and processing of Personal Data upon request.</p>

										<strong>System logs and maintenance</strong>
										<p>For operation and maintenance purposes, this Application and any third party services may collect files that record interaction with this Application (System logs) or use for this purpose other Personal Data (such as IP Address).</p>

										<strong>Information not contained in this policy</strong>
										<p>More details concerning the collection or processing of Personal Data may be requested from the Data Controller at any time. Please see the contact information at the beginning of this document.</p>

										<strong>The rights of Users</strong>
										<p>Users have the right, at any time, to know whether their Personal Data has been stored and can consult the Data Controller to learn about their contents and origin, to verify their accuracy or to ask for them to be supplemented, cancelled, updated or corrected, or for their transformation into anonymous format or to block any data held in violation of the law, as well as to oppose their treatment for any and all legitimate reasons. Requests should be sent to the Data Controller at the contact information set out above.</p>

										<strong>This Application does not support “Do Not Track” requests.</strong>
										<p>To determine whether any of the third party services it uses honour the “Do Not Track” requests, please read their privacy policies.</p>

										<strong>Changes to this privacy policy</strong>
										<p>The Data Controller reserves the right to make changes to this privacy policy at any time by giving notice to its Users on this page. It is strongly recommended to check this page often, referring to the date of the last modification listed at the bottom. If a User objects to any of the changes to the Policy, the User must cease using this Application and can request that the Data Controller remove the Personal Data. Unless stated otherwise, the then-current privacy policy applies to all Personal Data the Data Controller has about Users.</p>

										<strong>Information about this privacy policy</strong>
										<p>The Data Controller is responsible for this privacy policy.</p>
									</div>

									<hr>

									<div v-if="countryCodeSetting === 'UK'">
										<a target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/uk/documents/Likewize_Repair_Privacy_Policy.pdf">Click to see our full privacy policy</a> <img src="https://s3.eu-west-2.amazonaws.com/wefixuk/images/icons/Adobe_PDF_file_icon_32x32.png" alt="Adobe">
<!--										<a target="_blank" href="https://wefix-files.s3.eu-west-2.amazonaws.com/documents/wefix-privacy-policy-23-12-18.pdf">Click to see our full privacy policy</a> <img src="https://s3.eu-west-2.amazonaws.com/wefixuk/images/icons/Adobe_PDF_file_icon_32x32.png" alt="Adobe">-->
									</div>

									<div v-if="countryCodeSetting === 'AU'">
										<a target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/au/documents/Likewize_AU_Privacy_Policy.pdf">Click to see our full privacy policy</a> <img src="https://s3.eu-west-2.amazonaws.com/wefixuk/images/icons/Adobe_PDF_file_icon_32x32.png" alt="Adobe">
									</div>
								</div>
							</div>

						</dd>
					</div>
				</div>
			</div>
		</div>


		<!-- Footer -->
		<page-footer></page-footer>
	</div>
</template>

<script>
if (process.env.VUE_APP_PARTNER_ENVIRONMENT) {
	require('@/styles/core/whitelabel/'+process.env.VUE_APP_PARTNER_ENVIRONMENT+'.scss');
} else {
	require('@/styles/core/whitelabel/wefix.scss');
}

import {mapGetters} from "vuex";

export default {
	name: "PrivacyIndex",

	computed: {
		...mapGetters([
			'carrierDetails',
            'countryCodeSetting'
		])
	}
}
</script>

<style scoped>

</style>